import React, { Component } from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link
} from "react-router-dom";

import TokenStats from './TokenStats';

import zuzLogo from '../../assets/images/zuz-logo-filled-text.png';
import zuzLogoFilledNo from '../../assets/images/zuz-logo-filled-no.png';
import netOverlay from '../../assets/images/net-overlay.png';
import pyramid from '../../assets/images/pyramid.png';
import funnel from '../../assets/images/geyser-glow.png';
import Ethereum from '../../assets/images/ethereum.png';
import MetaMask from '../../assets/images/meta-mask.png';
import ChainCircle, { RightArrow, RefreshLogo } from '../Svg/index';



import RegisteredUserHeader from "./RegisteredUserHeader";
import RegisteredUserFooter from "./RegisteredUserFooter";
import RegisteredUserStats from "./RegisteredUserStats";
import styles from './stylesheets/RegisteredUser.module.css'

export class RegisteredUser extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isRegisteredUser: true,
        }
    }
    
    render() {
        return (
            <div className={styles.registeredUser}>
                <div className={styles.registeredUserBody}>
                    <RegisteredUserHeader></RegisteredUserHeader>
                    <RegisteredUserStats></RegisteredUserStats>
                    <TokenStats isRegisteredUser={this.state.isRegisteredUser}></TokenStats>
                </div>
                <RegisteredUserFooter></RegisteredUserFooter>
            </div>

        )
    }
}

export default RegisteredUser
